import type { ReactNode } from 'react';

import type { PanelItemColor, PanelItemSize } from '../types';

export type DataPanelItemBaseProps = {
  title?: string;
  value?: string;
  allowCopyToClipboard?: boolean;
  valueToCopy?: string;
  customPanelTemplate?: ReactNode;
  children?: ReactNode;
  actionItems?: ReactNode;
  showEmptyPlaceholder?: boolean;
  showEmptyPlaceholderWhen?: () => boolean;
  color?: PanelItemColor;
  linkUrl?: string;
  nonEmptyValueColor?: PanelItemColor;
  size?: PanelItemSize;
  editable?: boolean;
  onEditClick?: () => void | Promise<void>;
  clickable?: boolean;
  onPanelClick?: () => void | Promise<void>;
  hoverTooltip?: string;
};

export function isNullOrWhiteSpace(value: string | undefined): boolean {
  return value == null || value.trim() === '';
}

export function effectiveItemColor(props: DataPanelItemBaseProps): PanelItemColor {
  return !isNullOrWhiteSpace(props.value) && props.nonEmptyValueColor != null
    ? props.nonEmptyValueColor
    : (props.color ?? 'none');
}

export function effectiveSizeCssClass(props: DataPanelItemBaseProps): string {
  return (props.size ?? 'stretch') === 'stretch' ? 'col' : '';
}

export function effectivePanelBackgroundCssClass(props: DataPanelItemBaseProps): string {
  switch (effectiveItemColor(props)) {
    case 'none':
      return '';
    case 'excellent':
      return 'bg-success-subtle';
    case 'warning':
      return 'bg-warning-subtle';
    case 'critical':
      return 'bg-danger-subtle';
  }
}

export function clickableHoverClass(props: DataPanelItemBaseProps): string {
  return props.clickable ? 'data-panel-item__clickable' : '';
}
